<template>
  <div class="chart-container">
    <canvas ref="lineChart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'LineChart',
  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: 'Tanggal',
            },
          },
          y: {
            title: {
              display: true,
              text: 'Utitilas Harian',
            },
            beginAtZero: true,
            suggestedMax: 100,
          },
        },
      }),
    },
  },

  mounted() {
    this.updateChartOptions();
    this.renderChart();
  },

  watch: {
    data: {
      deep: true,
      handler() {
        this.updateChartOptions();
        this.renderChart();
      }
    }
  },

  methods: {
    updateChartOptions() {
      if (this.data.datasets.length) {
        const maxDataValue = Math.max(...this.data.datasets.flatMap(ds => ds.data));
        this.options.scales.y.suggestedMax = maxDataValue + Math.ceil(maxDataValue * 0.2);
      }
    },

    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      const ctx = this.$refs.lineChart.getContext('2d');

      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.data,
        options: this.options,
      });
    }
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>

<style scoped>
.chart-container {
  height: 350px; 
}
</style>
